module.exports = __webpack_public_path__ + "fonts/dm-sans-v10-latin-700.3c5fc6e.woff";